"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupByDate = void 0;
const date_fns_1 = require("date-fns");
const lodash_1 = require("lodash");
const sortBy_1 = require("./sortBy");
/**
 * Periodの配列を日ごとにグループ化して返す
 * @param periods
 */
const groupByDate = (periods) => {
    // 先に降順ソートしておく
    const sortedPeriods = (0, sortBy_1.sortBy)(periods, (p) => p.start, 'asc');
    const groupByDate = (0, lodash_1.groupBy)(sortedPeriods, (p) => (0, date_fns_1.startOfDay)(p.start));
    return Object.entries(groupByDate).map(([dateString, periods]) => {
        return {
            date: new Date(dateString),
            periods
        };
    });
};
exports.groupByDate = groupByDate;
//# sourceMappingURL=groupPeriodsBy.js.map